import {hashify} from 'src/pages/category/utils';
import {topics as topicsSelector} from 'src/pages/category/store/selectors/topics';

export const CHANGE_TOPICS = 'CHANGE_TOPICS';

export const changeTopics = (topic, subtopic) => ({
  type: CHANGE_TOPICS,
  value: {topic, subtopic},
});

export const loadTopics = () => (dispatch, getState) => {
  const topics = topicsSelector(getState());
  const onMobile = window.matchMedia('(max-width: 530px)').matches;
  const [, topicHash, subtopicHash] = /#([^\/]*)(?:\/(.*))?/.exec(window.location.hash) || [];
  let topic = topics.find(topic => hashify(topic.name) === topicHash);
  if (!topic && !onMobile) {
    topic = topics[0];
  }
  const subtopic = topic?.subtopics.length === 1
    ? topic.subtopics[0]
    : topic?.subtopics.find(subtopic => hashify(subtopic.name) === subtopicHash);
  dispatch(changeTopics(topic, subtopic));
};
